import {getStateWithOnlyOneLevel} from '../utils/StateSelectorHelper';

const getState = state => getStateWithOnlyOneLevel(state, 'App');

export const getAppTheme = state => getState(state).get('appTheme');
export const getLoading = state => getState(state).get('loadingAppTheme');
export const getOpenDisabledModal = state => getState(state).get('openDisabledCourseModal');
export const getSubmitOpenDisabledModal = state =>
  getState(state).get('submitedOpenDisabledCourseModal');
